module.exports = __webpack_public_path__ + "static/media/logo.f3eab777.svg";